import React from "react";
import { WooCommerceCheckoutBlock } from "@/integrations/wordpress/WooCommerceCheckoutBlock";
export default function CheckoutContent() {
  return <section data-section-id="224801" id="checkout-content" className="bg-background text-foreground py-16 md:py-24 px-4 sm:px-8">
      <div className="max-w-screen-xl mx-auto">
        <div className="mb-12">
          <h1 className="font-default text-4xl md:text-6xl font-bold text-primary mb-4 tracking-tight">
            Finalize Your Order
          </h1>
          <p className="font-default text-muted-foreground text-lg max-w-2xl leading-relaxed">
            Securely complete your purchase of artisan breads and pastries. Enter your details below to bring the warmth of CRUST to your home.
          </p>
        </div>

        <div className="bg-card text-card-foreground rounded-lg shadow-sm p-6 md:p-8 border border-border backdrop-blur-sm">
          <WooCommerceCheckoutBlock />
        </div>
      </div>
    </section>;
}